import {
  GET_LOANS,
  LOADING_GET_LOANS,
  ERROR_GETTING_LOANS,
  SET_LOAN,
} from "../types";

const INITIAL_STATE = {
  loans: [],
  loan: {},
  loadingGetLoans: false,
  errorGettingLoans: false,
};

const loansReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_LOANS:
      return { ...state, loans: action.payload };
    case SET_LOAN:
      const loanIndex = state.loans.findIndex(
        (el) => el._id === action.payload._id
      );
      const loans = [...state.loans];
      if (loanIndex !== -1) {
        loans[loanIndex] = action.payload;
      }
      return { ...state, loan: action.payload, loans };
    case LOADING_GET_LOANS:
      return { ...state, loadingGetLoans: action.payload };
    case ERROR_GETTING_LOANS:
      return { ...state, errorGettingLoans: action.payload };

    default:
      return state;
  }
};

export default loansReducer;
